import React from "react";
import { Button } from "semantic-ui-react";
import { cleanRecover } from "../../../../app/store/actions/recoverActions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const actions = {
  cleanRecover,
};

const RecoverCancel = ({ cleanRecover }) => {
  return (
    <Button
      fluid
      size="large"
      color="blue"
      content="Cancelar"
      onClick={() => cleanRecover()}
      as={Link}
      to="/"
    />
  );
};
RecoverCancel.propTypes = {
  cleanRecover: PropTypes.func.isRequired,
};
export default connect(null, actions)(RecoverCancel);
